import { render } from "./CasePage-View.vue?vue&type=template&id=0c85850e"
import script from "./CasePage-View.vue?vue&type=script&lang=js"
export * from "./CasePage-View.vue?vue&type=script&lang=js"

import "./CasePage-View.vue?vue&type=style&index=0&id=0c85850e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__